import React from 'react';
import { Badge } from 'react-bootstrap';

export const RunItemCard = ({
  title = 'Activity',
  subtitle = '',
  detail = '',
  statusLabel = '',
  statusVariant = 'secondary',
  meta = '',
  isSelected = false,
  onClick = null,
  disabled = false,
}) => {
  const Wrapper = onClick ? 'button' : 'div';

  return (
    <Wrapper
      type={onClick ? 'button' : undefined}
      className={`run-item-card text-start ${isSelected ? 'run-item-card--selected' : ''}`}
      onClick={onClick || undefined}
      disabled={onClick ? disabled : undefined}
    >
      <div className="d-flex justify-content-between align-items-start gap-2">
        <div className="run-item-card__content">
          <div className="run-item-card__title">{title}</div>
          {subtitle ? <div className="run-item-card__subtitle">{subtitle}</div> : null}
          {detail ? <div className="run-item-card__detail">{detail}</div> : null}
        </div>
        {statusLabel ? (
          <Badge bg={statusVariant} className="text-uppercase run-item-card__badge">
            {statusLabel}
          </Badge>
        ) : null}
      </div>
      {meta ? <div className="run-item-card__meta">{meta}</div> : null}
    </Wrapper>
  );
};
